import React from "react";
import AutoTarget from "../../assets/images/marketing-prof/autoTarget.png";
import omniChannel from "../../assets/images/marketing-prof/omnichennal.png";
import dataDrivenInsights from "../../assets/images/marketing-prof/dataDrivenInsights.png";
import automatedLeadGen from "../../assets/images/marketing-prof/automatedLeadGen.png";
import seamlessInteg from "../../assets/images/marketing-prof/seamless-integ.png";
import contentPerson from "../../assets/images/marketing-prof/content-person.png";

const features = [
  {
    title: "Precise Audience Targeting",
    desc: "BeyondLeadz allows you to build highly targeted lists based on demographics, behaviors, and interests. Whether you’re launching a new campaign or refining an existing one, our tools ensure you’re reaching the right people, at the right time, with the right message.",
    img: AutoTarget,
  },
  {
    title: "Omnichannel Campaign Management",
    desc: "Manage all your marketing channels—email, social media, web, and more—from a single, integrated platform. Coordinate campaigns across multiple touchpoints to create a cohesive and consistent brand experience.",
    img: omniChannel,
  },
  {
    title: "Data-Driven Insights",
    desc: "Make informed decisions with real-time analytics and reporting. Track campaign performance, monitor key metrics, and gain insights into what’s working and what’s not, so you can optimize your strategies for maximum impact.",
    img: dataDrivenInsights,
  },
  {
    title: "Automated Lead Nurturing",
    desc: "Set up automated workflows to nurture leads through the funnel, delivering personalized content and messages based on their interactions with your brand. BeyondLeadz helps you keep leads engaged and moving toward conversion without manual intervention.",
    img: automatedLeadGen,
  },
  {
    title: "Seamless Integrations",
    desc: "BeyondLeadz integrates with your favorite marketing tools and platforms—like Gmail, Facebook, LinkedIn, and more—ensuring your data flows seamlessly across systems, saving you time and reducing errors.",
    img: seamlessInteg,
  },
  {
    title: "Content Personalization",
    desc: "Use enriched data to create personalized marketing content that resonates with your audience. Leadz helps you tailor your messaging to meet the unique needs and preferences of each segment, increasing engagement and conversion rates.",
    img: contentPerson,
  },
];

const FeaturesList = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-5xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-20">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Grow Your Audience
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Why Marketing Professionals <br />
            Should Use <span className="tw-text-[#5D44FF]">BeyondLeadz</span>
          </h2>
        </div>

        {/* Alternating Layout Blocks */}
        <div className="tw-space-y-12">
          {features.map((item, idx) => {
            const isEven = idx % 2 === 0;
            return (
              <div
                key={idx}
                className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-[32px] tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-300"
              >
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-8 tw-items-center">
                  
                  {/* Text Container */}
                  <div className={`md:tw-col-span-7 tw-text-left ${isEven ? "md:tw-order-1" : "md:tw-order-2"}`}>
                    <div className="tw-inline-block tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-mb-3">
                      Feature 0{idx + 1}
                    </div>
                    <h3 className="tw-text-lg sm:tw-text-xl tw-font-extrabold tw-text-slate-800 tw-mb-4">
                      {item.title}
                    </h3>
                    <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                      {item.desc}
                    </p>
                  </div>

                  {/* Image Container */}
                  <div className={`md:tw-col-span-5 tw-flex tw-justify-center ${isEven ? "md:tw-order-2" : "md:tw-order-1"}`}>
                    <div className="tw-overflow-hidden tw-rounded-2xl tw-bg-slate-50 tw-p-2 tw-border tw-border-solid tw-border-slate-100 tw-shadow-sm hover:tw-scale-[1.03] tw-transition-transform tw-duration-300">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="tw-max-w-full tw-h-auto tw-object-contain tw-rounded-lg"
                        loading="lazy"
                      />
                    </div>
                  </div>

                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default FeaturesList;
